import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

import ActionCharts from '@/components/statistics/ActionCharts.vue';
import Co2ScanCharts from '@/components/statistics/Co2ScanCharts.vue';
import QuizCharts from '@/components/statistics/QuizCharts.vue';
import StatisticsMenu from '@/components/statistics/StatisticsMenu.vue';
import UserCharts from '@/components/statistics/UserCharts.vue';
import { useRoute } from 'vue-router';


export default /*@__PURE__*/_defineComponent({
  __name: 'StatisticsChartView',
  setup(__props) {

const route = useRoute();

return (_ctx: any,_cache: any) => {
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(StatisticsMenu, { item: "Quiz of the day" }),
    _createVNode(_component_v_container, null, {
      default: _withCtx(() => [
        (_unref(route).params.slug === 'quizzes')
          ? (_openBlock(), _createBlock(QuizCharts, { key: 0 }))
          : _createCommentVNode("", true),
        (_unref(route).params.slug === 'actions')
          ? (_openBlock(), _createBlock(ActionCharts, { key: 1 }))
          : _createCommentVNode("", true),
        (_unref(route).params.slug === 'co2-scan')
          ? (_openBlock(), _createBlock(Co2ScanCharts, { key: 2 }))
          : _createCommentVNode("", true),
        (_unref(route).params.slug === 'user-interests')
          ? (_openBlock(), _createBlock(UserCharts, { key: 3 }))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ], 64))
}
}

})